import { useAuth0 } from "@auth0/auth0-react";
// import { useEffect } from "react";

const PostLogin = () => {
  //   const [searchParams] = useSearchParams();
  const { logout, loginWithRedirect } = useAuth0();

  /* useEffect(() => {
    loginWithRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); */

  const login = () => {
    console.log("PostLogin: login: calling loginWithRedirect")
    loginWithRedirect();
  };

  return (
    <>
      {/* Username: {JSON.stringify(user)}
      <button onClick={() => logout()}>Logout</button>
      <button onClick={login}>Login</button> */}
      <div className="container-scroller ">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0 login-background">
            <div className="row w-100 mx-0">
              <div className="col-lg-4 mx-auto">
                <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                  <h4 className="signintext">
                    <span>
                      <b>Verify your email</b>
                    </span>
                  </h4>
                  <h6 className="font-weight-light subheading-email">
                    Kindly check you email and click on verify, then come back
                    here and{" "}
                    <span className="link" onClick={login}>
                      click here
                    </span>{" "}
                    to login.
                    <br />
                    <br />
                    OR you can login from login screen any time after verifieng
                    your email.
                  </h6>
                  <button className="btn btn-primary" onClick={(e) => logout()}>
                    Go back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PostLogin;
